define(["dojo-proxy-loader?name=dojo/_base/declare!/home/mcdeploy/mc_node_modules_cache/c498397e31349a8eda9bac015e0a41b85d051368/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dijit/_WidgetBase", "dijit/_TemplatedMixin", "dijit/_FocusMixin", "dojo-proxy-loader?name=dojo/_base/array!/home/mcdeploy/mc_node_modules_cache/c498397e31349a8eda9bac015e0a41b85d051368/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dojo-proxy-loader?name=dojo/query!/home/mcdeploy/mc_node_modules_cache/c498397e31349a8eda9bac015e0a41b85d051368/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dojo-proxy-loader?name=dojo/on!/home/mcdeploy/mc_node_modules_cache/c498397e31349a8eda9bac015e0a41b85d051368/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dojo-proxy-loader?name=dojo/_base/lang!/home/mcdeploy/mc_node_modules_cache/c498397e31349a8eda9bac015e0a41b85d051368/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dojo-proxy-loader?name=dojo/dom-form!/home/mcdeploy/mc_node_modules_cache/c498397e31349a8eda9bac015e0a41b85d051368/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dojo-proxy-loader?name=dojo/dom-geometry!/home/mcdeploy/mc_node_modules_cache/c498397e31349a8eda9bac015e0a41b85d051368/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dojo-proxy-loader?name=dojo/dom-construct!/home/mcdeploy/mc_node_modules_cache/c498397e31349a8eda9bac015e0a41b85d051368/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dojo-proxy-loader?name=dojo/dom-style!/home/mcdeploy/mc_node_modules_cache/c498397e31349a8eda9bac015e0a41b85d051368/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dojo-proxy-loader?name=dojo/dom-attr!/home/mcdeploy/mc_node_modules_cache/c498397e31349a8eda9bac015e0a41b85d051368/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dojo/html", "dojo-proxy-loader?name=dojo/Evented!/home/mcdeploy/mc_node_modules_cache/c498397e31349a8eda9bac015e0a41b85d051368/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dojo/promise/all", "dojo-proxy-loader?name=dojo/Deferred!/home/mcdeploy/mc_node_modules_cache/c498397e31349a8eda9bac015e0a41b85d051368/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dojo-proxy-loader?name=dojo/sniff!/home/mcdeploy/mc_node_modules_cache/c498397e31349a8eda9bac015e0a41b85d051368/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dojo/cookie", "dojox/html/entities", "dojox/widget/Toaster", "mojo/widgets/_CustomStyleRulesMixin", "mojo/page/request"], function (declare, _WidgetBase, _TemplatedMixin, _FocusMixin, array, query, on, lang, domForm, domGeom, domConstruct, domStyle, domAttr, html, Evented, all, Deferred, has, cookie, entities, Toaster, _CustomStyleRulesMixin, request) {
  var translations = {};
  var globalConfig = {};
  var _ValidationTypes = declare([], {
    /* Field (one or more inputs) Validation Methods */
    isEmpty: function () {
      var valid;
      array.forEach(this.inputs, lang.hitch(this, function (input) {
        if (input.type === "radio" || input.type === "checkbox" || input.tagName.toLowerCase() === "option") {
          valid = typeof valid === "boolean" ? valid && !this._checked(input) : !this._checked(input);
        } else {
          valid = typeof valid === "boolean" ? valid && this._empty(input.value) : this._empty(input.value);
        }
      }));
      return valid;
    },
    isValidSMSPhoneNumber: function () {
      return true;
    },
    isSMSTermsAcknowledged: function () {
      //if required - the SMSPHONE should have 2 input fields
      //1 - the text input for the number
      //2 - the acknowldedge checkbox (always 2nd)
      if (this.inputs.length === 2 && this.inputs[1].type === "checkbox") {
        return this.inputs[1].checked;
      }
      return true;
    },
    // At least one option is selected. Use array.some so we can return true as soon as we find a checked input.
    isChecked: function () {
      array.some(this.inputs, lang.hitch(this, function (input) {
        if (this._checked(input)) {
          return true;
        }
      }));
      return false;
    },
    // An email field contains one input
    isEmail: function () {
      return this._email(this.inputs[0].value);
    },
    // A phone field contains three inputs: area, detail1 and detail2
    isPhone: function () {
      return this._phone(this.phoneAreaNode.value, this.phoneDetail1Node.value, this.phoneDetail2Node.value);
    },
    isUrl: function () {
      return this._url(this.inputs[0].value);
    },
    isNumber: function () {
      return this._number(this.inputs[0].value);
    },
    isBirthday: function () {
      return this._monthDigits(this.monthNode.value) && this._dayDigits(this.dayNode.value);
    },
    isDate: function () {
      return this._yearDigits(this.yearNode.value) && this._monthDigits(this.monthNode.value) && this._dayDigits(this.dayNode.value);
    },
    isAddress: function () {
      return !this._empty(this.address1Node.value) && !this._empty(this.cityNode.value) && !this._empty(this.stateNode.value) && this._checked(query(":checked", this.countrySelectNode)[0]) && !this._empty(this.zipNode.value);
    },
    /* Single Input Validation Methods */
    _required: function (value) {
      return value.trim().length > 0;
    },
    _empty: function (value) {
      return value === null || typeof value === "undefined" || value === "";
    },
    _email: function (value) {
      return /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(value);
    },
    // YYYY [all the digits, i.e. 2012]
    _yearDigits: function (value) {
      return this._digits(value) && this._range(value, [1, 9999]);
    },
    // MM [01 (January) to 12 (December)]
    _monthDigits: function (value) {
      return this._digits(value) && this._range(value, [1, 12]);
    },
    // DD [01 to 31]
    _dayDigits: function (value) {
      return this._digits(value) && this._range(value, [1, 31]);
    },
    _digits: function (value) {
      return /^\d+$/.test(value);
    },
    _range: function (value, param) {
      return value >= param[0] && value <= param[1];
    },
    _number: function (value) {
      return this._digits(value) && !isNaN(value);
    },
    _minlength: function (value, param) {
      return value.trim().length >= param;
    },
    _maxlength: function (value, param) {
      return value.trim().length <= param;
    },
    _exactLength: function (value, param) {
      return value.trim().length === param;
    },
    // US zip code
    _zipcode: function (value) {
      return /^\d{5}-\d{4}$|^\d{5}$/.test(value);
    },
    _url: function (value) {
      return /^(https?|s?ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(value);
    },
    /* Custom Validation Methods */
    _phone: function (area, detail1, detail2) {
      return this._digits(area) && this._digits(detail1) && this._digits(detail2) && this._exactLength(area, 3) && this._exactLength(detail1, 3) && this._exactLength(detail2, 4);
    },
    _checked: function (node) {
      return node.checked || node.selected && !this._empty(node.value);
    },
    /* Utility Methods */
    _checkable: function (node) {
      return /radio|checkbox/i.test(node.type);
    }
  });
  var _ValidationMixin = declare([_FocusMixin, _ValidationTypes], {
    // TODO: Allow users to supply custom validation messages?

    _onBlur: function () {
      this.inherited(arguments);
      this.validateField();
    },
    validateField: function () {
      var errors = [];
      var valid, message;
      if (this.required) {
        valid = !this.isEmpty(); // TODO: What about the address field which has inputs (e.g., address2) that can be empty?

        if (!valid) {
          errors.push(translations["9303c9bd4f8178680dc382adbfcd62af"]);
        }
        // In english, translates to "This field is required."
      }
      switch (this.validateAsType) {
        case "email":
          valid = this.isEmpty() || this.isEmail();
          message = translations["b5bccda6d3a04e1d8f79846355290435"];
          // In english, translates to  "Please enter a valid email address."; // TODO: Make this part of the form widget?
          break;
        case "address":
          valid = this.isEmpty() || this.isAddress();
          message = translations["65072e37cef3c8e8fe8873937664c67c"];
          // In english, translates to  "Please enter a valid address.";
          break;
        case "phone":
          valid = this.isEmpty() || this.isPhone();
          message = translations["7724076d0ccc93dbb00326dbedfeee14"];
          // In english, translates to  "Please enter a valid phone number.";
          break;
        case "smsphone":
          valid = this.isValidSMSPhoneNumber();
          message = translations["7724076d0ccc93dbb00326dbedfeee14"];
          //Phone validation passed - now checking acknowledge checkbox if required
          if (valid && this.required) {
            if (!this.isSMSTermsAcknowledged()) {
              valid = false;
              message = "Must acknowledge SMS terms.";
            }
          }
          break;
        case "url":
          valid = this.isEmpty() || this.isUrl(); // TODO: image url validation?
          message = translations["2918dd459b068924e2b6d6df3faa2a47"];
          // In english, translates to  "Please enter a valid url.";
          break;
        case "number":
          valid = this.isEmpty() || this.isNumber();
          message = translations["aae0933b5535a899ca6a790ef963de38"];
          // In english, translates to  "Please enter a valid number.";
          break;
        case "birthday":
          valid = this.isEmpty() || this.isBirthday();
          message = translations["08e0d7dddecd2fbebae22aa3f9d5241d"];
          // In english, translates to  "Please enter a valid birthday.";
          break;
        case "date":
          valid = this.isEmpty() || this.isDate();
          message = translations["773fcd7a2070fcf96c72ea6540c77eb8"];
          // In english, translates to  "Please enter a valid date.";
          break;
        case "radiocheckbox":
        case "select":
          valid = this.isEmpty() || this.isChecked();
        default:
          valid = true;
        // NOTE: generic text inputs are valid by default
      }
      if (!valid) {
        errors.push(message);
      }
      this.setFieldValidationStatus(errors);
      return errors;
    },
    setFieldValidationStatus: function (errors) {
      if (errors.length > 0) {
        this.setFieldAsInvalid(errors[0]);
      } else {
        this.setFieldAsValid();
      }
    },
    setFieldAsInvalid: function (message) {
      this.inputs.addClass("invalid").removeClass("valid");
      html.set(this.errorsNode, message);
      domStyle.set(this.errorsNode, "display", "block");
    },
    setFieldAsValid: function () {
      this.inputs.addClass("valid").removeClass("invalid");
      domStyle.set(this.errorsNode, "display", "none");
    },
    resetField: function () {
      this.inputs.removeClass("valid").removeClass("invalid");
      domStyle.set(this.errorsNode, "display", "none");
    },
    _getErrorsNode: function () {
      var node = query(".invalid-error", this.domNode)[0];
      if (!node) {
        node = domConstruct.place('<div class="invalid-error"></div>', this.domNode);
      }
      return node;
    }
  });
  var _BaseField = declare([_WidgetBase, _TemplatedMixin, _ValidationMixin], {
    required: false,
    inputs: [],
    errorsNode: null,
    postCreate: function () {
      this.inputs = query("input:not([type='hidden']), select option", this.domNode);
      this.errorsNode = this._getErrorsNode();
    }
  });
  var SmsPhoneField = declare([_BaseField], {
    templateString: "<div class=\"field-wrapper sms-phone-field\">" + "<div data-dojo-attach-point=\"smsLabel\" style=\"display: flex; justify-content: space-between;\">" + "<label for=\"mc-${name}\">${label}</label>" + "</div>" + "<div data-dojo-attach-point=\"smsInputWrapper\">" + "<input type=\"text\" name=\"${name}\" value=\"\" id=\"mc-${name}\" data-dojo-attach-point=\"smsPhoneInput\"/>" + "</div>" + "<div id=\"sms-terms-container\" style=\"display: flex;\">" + "<div data-dojo-attach-point=\"smsLegal\" style=\"margin-bottom: 20px;font-size: 12px;line-height: 140%;\"></div>" + "</div>" + "</div>",
    validateAsType: "smsphone",
    legalCopy: "",
    smsProgramData: null,
    _builAckNode: function () {
      return "<label class=\"checkbox\" style=\"margin-top: -5px;\">" + "<input type=\"checkbox\" name=\"mc-SMSPHONE-ack\" id=\"mc-SMSPHONE-ack\" value=\"true\" />" + "<span>&nbsp;</span>" + "</label>";
    },
    postCreate: function () {
      var legalNode;
      var smsPrefix;
      if (this.smsProgramData) {
        smsPrefix = domConstruct.toDom("<span " + 'data-dojo-attach-point="smsPrefix" ' + "id={prefixTextId} " + "className={stylesheet.inputPrefix} " + 'style="display:flex;position:absolute;padding-left:16px;padding-right:4px;">' + "<img " + 'src="' + this.smsProgramData[0].imgSrc + '" ' + 'alt="Country Code" width="28" height="28">' + "</img>" + "</span>");
        domConstruct.place(smsPrefix, this.smsInputWrapper, 0);
        domStyle.set(this.smsInputWrapper, "display", "flex");
        domStyle.set(this.smsInputWrapper, "margin-bottom", "5px");
        domStyle.set(this.smsInputWrapper, "align-items", "center");
        domStyle.set(this.smsPhoneInput, "margin", "unset");
        domStyle.set(this.smsPhoneInput, "padding-left", "48px");
      }
      if (this.required) {
        legalNode = domConstruct.toDom("<div>" + (this.smsProgramData ? this.smsProgramData[0].requiredTemplate : this.legal.required) + "</div>");
        domConstruct.place(this._builAckNode(), this.smsLegal, "before");
      } else {
        legalNode = domConstruct.toDom("<div>" + (this.smsProgramData ? this.smsProgramData[0].optionalTemplate : this.legal.optional) + "</div>");
        var optionalTag = "<span class=\"field-help\" style=\"width: auto; font-weight: lighter;\">" + globalConfig.optionLabel + "</span>";
        domConstruct.place(optionalTag, this.smsLabel, "last");
      }
      domConstruct.place(legalNode, this.smsLegal);
      this.inherited(arguments);
    }
  });
  var TextField = declare([_BaseField], {
    templateString: '<div class="field-wrapper">' + '<label for="mc-${name}">${label}</label>' + '<input type="text" name="${name}" value="" id="mc-${name}" />' + "</div>",
    validateAsType: "text"
  });
  var NumberField = declare([_BaseField], {
    templateString: "<div class='field-wrapper'>" + "<label for='mc-${name}'>${label}</label>" + "<input type='text' name='${name}' value='' id='mc-${name}' />" + "</div>",
    validateAsType: "number"
  });
  var AddressField = declare([_BaseField], {
    templateString: "<div class='field-wrapper address'>" + "<div>" + "<label for='mc-${name}-addr1'>${label}</label>" + "<input class='address1' type='text' name='${name}[addr1]' value='' id='mc-${name}-addr1' data-dojo-attach-point='address1Node' />" + "</div>" + "<div>" + "<label for='mc-${name}-addr2'>${addr2}</label>" + "<input class='address2' type='text' name='${name}[addr2]' value='' id='mc-${name}-addr2' />" + "</div>" + "<div>" + "<label for='mc-${name}-city'>${city}</label>" + "<input class='city' type='text' name='${name}[city]' value='' id='mc-${name}-city' data-dojo-attach-point='cityNode' />" + "</div>" + "<div>" + "<label for='mc-${name}-state'>${state}</label>" + "<input class='state' type='text' name='${name}[state]' value='' id='mc-${name}-state' data-dojo-attach-point='stateNode' />" + "</div>" + "<div>" + "<label for='mc-${name}-zip'>${zip}</label>" + "<input class='zip' type='text' name='${name}[zip]' value='' id='mc-${name}-zip' data-dojo-attach-point='zipNode' />" + "</div>" + "<div>" + "<label for='mc-${name}-country'>${country}</label>" + "<select class='country' name='${name}[country]' id='mc-${name}-country' data-dojo-attach-point='countrySelectNode'>" + "<option value='' selected></option>" + "<option value='164'>USA</option>" + "</select>" + "</div>" + "</div>",
    validateAsType: "address",
    postCreate: function () {
      var countries = [{
        "id": "286",
        "name": "Aaland Islands"
      }, {
        "id": "274",
        "name": "Afghanistan"
      }, {
        "id": "2",
        "name": "Albania"
      }, {
        "id": "3",
        "name": "Algeria"
      }, {
        "id": "178",
        "name": "American Samoa"
      }, {
        "id": "4",
        "name": "Andorra"
      }, {
        "id": "5",
        "name": "Angola"
      }, {
        "id": "176",
        "name": "Anguilla"
      }, {
        "id": "175",
        "name": "Antigua And Barbuda"
      }, {
        "id": "6",
        "name": "Argentina"
      }, {
        "id": "7",
        "name": "Armenia"
      }, {
        "id": "179",
        "name": "Aruba"
      }, {
        "id": "8",
        "name": "Australia"
      }, {
        "id": "9",
        "name": "Austria"
      }, {
        "id": "10",
        "name": "Azerbaijan"
      }, {
        "id": "11",
        "name": "Bahamas"
      }, {
        "id": "12",
        "name": "Bahrain"
      }, {
        "id": "13",
        "name": "Bangladesh"
      }, {
        "id": "14",
        "name": "Barbados"
      }, {
        "id": "15",
        "name": "Belarus"
      }, {
        "id": "16",
        "name": "Belgium"
      }, {
        "id": "17",
        "name": "Belize"
      }, {
        "id": "18",
        "name": "Benin"
      }, {
        "id": "19",
        "name": "Bermuda"
      }, {
        "id": "20",
        "name": "Bhutan"
      }, {
        "id": "21",
        "name": "Bolivia"
      }, {
        "id": "22",
        "name": "Bosnia and Herzegovina"
      }, {
        "id": "23",
        "name": "Botswana"
      }, {
        "id": "181",
        "name": "Bouvet Island"
      }, {
        "id": "24",
        "name": "Brazil"
      }, {
        "id": "180",
        "name": "Brunei Darussalam"
      }, {
        "id": "25",
        "name": "Bulgaria"
      }, {
        "id": "26",
        "name": "Burkina Faso"
      }, {
        "id": "27",
        "name": "Burundi"
      }, {
        "id": "28",
        "name": "Cambodia"
      }, {
        "id": "29",
        "name": "Cameroon"
      }, {
        "id": "30",
        "name": "Canada"
      }, {
        "id": "31",
        "name": "Cape Verde"
      }, {
        "id": "32",
        "name": "Cayman Islands"
      }, {
        "id": "33",
        "name": "Central African Republic"
      }, {
        "id": "34",
        "name": "Chad"
      }, {
        "id": "35",
        "name": "Chile"
      }, {
        "id": "36",
        "name": "China"
      }, {
        "id": "185",
        "name": "Christmas Island"
      }, {
        "id": "37",
        "name": "Colombia"
      }, {
        "id": "204",
        "name": "Comoros"
      }, {
        "id": "38",
        "name": "Congo"
      }, {
        "id": "183",
        "name": "Cook Islands"
      }, {
        "id": "268",
        "name": "Costa Rica"
      }, {
        "id": "275",
        "name": "Cote D'Ivoire"
      }, {
        "id": "40",
        "name": "Croatia"
      }, {
        "id": "276",
        "name": "Cuba"
      }, {
        "id": "298",
        "name": "Curacao"
      }, {
        "id": "41",
        "name": "Cyprus"
      }, {
        "id": "42",
        "name": "Czech Republic"
      }, {
        "id": "43",
        "name": "Denmark"
      }, {
        "id": "44",
        "name": "Djibouti"
      }, {
        "id": "289",
        "name": "Dominica"
      }, {
        "id": "187",
        "name": "Dominican Republic"
      }, {
        "id": "233",
        "name": "East Timor"
      }, {
        "id": "45",
        "name": "Ecuador"
      }, {
        "id": "46",
        "name": "Egypt"
      }, {
        "id": "47",
        "name": "El Salvador"
      }, {
        "id": "48",
        "name": "Equatorial Guinea"
      }, {
        "id": "49",
        "name": "Eritrea"
      }, {
        "id": "50",
        "name": "Estonia"
      }, {
        "id": "51",
        "name": "Ethiopia"
      }, {
        "id": "189",
        "name": "Falkland Islands"
      }, {
        "id": "191",
        "name": "Faroe Islands"
      }, {
        "id": "52",
        "name": "Fiji"
      }, {
        "id": "53",
        "name": "Finland"
      }, {
        "id": "54",
        "name": "France"
      }, {
        "id": "193",
        "name": "French Guiana"
      }, {
        "id": "277",
        "name": "French Polynesia"
      }, {
        "id": "56",
        "name": "Gabon"
      }, {
        "id": "57",
        "name": "Gambia"
      }, {
        "id": "58",
        "name": "Georgia"
      }, {
        "id": "59",
        "name": "Germany"
      }, {
        "id": "60",
        "name": "Ghana"
      }, {
        "id": "194",
        "name": "Gibraltar"
      }, {
        "id": "61",
        "name": "Greece"
      }, {
        "id": "195",
        "name": "Greenland"
      }, {
        "id": "192",
        "name": "Grenada"
      }, {
        "id": "196",
        "name": "Guadeloupe"
      }, {
        "id": "62",
        "name": "Guam"
      }, {
        "id": "198",
        "name": "Guatemala"
      }, {
        "id": "270",
        "name": "Guernsey"
      }, {
        "id": "63",
        "name": "Guinea"
      }, {
        "id": "65",
        "name": "Guyana"
      }, {
        "id": "200",
        "name": "Haiti"
      }, {
        "id": "66",
        "name": "Honduras"
      }, {
        "id": "67",
        "name": "Hong Kong"
      }, {
        "id": "68",
        "name": "Hungary"
      }, {
        "id": "69",
        "name": "Iceland"
      }, {
        "id": "70",
        "name": "India"
      }, {
        "id": "71",
        "name": "Indonesia"
      }, {
        "id": "278",
        "name": "Iran"
      }, {
        "id": "279",
        "name": "Iraq"
      }, {
        "id": "74",
        "name": "Ireland"
      }, {
        "id": "75",
        "name": "Israel"
      }, {
        "id": "76",
        "name": "Italy"
      }, {
        "id": "202",
        "name": "Jamaica"
      }, {
        "id": "78",
        "name": "Japan"
      }, {
        "id": "288",
        "name": "Jersey (Channel Islands)"
      }, {
        "id": "79",
        "name": "Jordan"
      }, {
        "id": "80",
        "name": "Kazakhstan"
      }, {
        "id": "81",
        "name": "Kenya"
      }, {
        "id": "203",
        "name": "Kiribati"
      }, {
        "id": "82",
        "name": "Kuwait"
      }, {
        "id": "83",
        "name": "Kyrgyzstan"
      }, {
        "id": "84",
        "name": "Lao People's Democratic Republic"
      }, {
        "id": "85",
        "name": "Latvia"
      }, {
        "id": "86",
        "name": "Lebanon"
      }, {
        "id": "87",
        "name": "Lesotho"
      }, {
        "id": "88",
        "name": "Liberia"
      }, {
        "id": "281",
        "name": "Libya"
      }, {
        "id": "90",
        "name": "Liechtenstein"
      }, {
        "id": "91",
        "name": "Lithuania"
      }, {
        "id": "92",
        "name": "Luxembourg"
      }, {
        "id": "208",
        "name": "Macau"
      }, {
        "id": "93",
        "name": "Macedonia"
      }, {
        "id": "94",
        "name": "Madagascar"
      }, {
        "id": "95",
        "name": "Malawi"
      }, {
        "id": "96",
        "name": "Malaysia"
      }, {
        "id": "97",
        "name": "Maldives"
      }, {
        "id": "98",
        "name": "Mali"
      }, {
        "id": "99",
        "name": "Malta"
      }, {
        "id": "207",
        "name": "Marshall Islands"
      }, {
        "id": "210",
        "name": "Martinique"
      }, {
        "id": "100",
        "name": "Mauritania"
      }, {
        "id": "212",
        "name": "Mauritius"
      }, {
        "id": "241",
        "name": "Mayotte"
      }, {
        "id": "101",
        "name": "Mexico"
      }, {
        "id": "102",
        "name": "Moldova, Republic of"
      }, {
        "id": "103",
        "name": "Monaco"
      }, {
        "id": "104",
        "name": "Mongolia"
      }, {
        "id": "290",
        "name": "Montenegro"
      }, {
        "id": "294",
        "name": "Montserrat"
      }, {
        "id": "105",
        "name": "Morocco"
      }, {
        "id": "106",
        "name": "Mozambique"
      }, {
        "id": "242",
        "name": "Myanmar"
      }, {
        "id": "107",
        "name": "Namibia"
      }, {
        "id": "108",
        "name": "Nepal"
      }, {
        "id": "109",
        "name": "Netherlands"
      }, {
        "id": "110",
        "name": "Netherlands Antilles"
      }, {
        "id": "213",
        "name": "New Caledonia"
      }, {
        "id": "111",
        "name": "New Zealand"
      }, {
        "id": "112",
        "name": "Nicaragua"
      }, {
        "id": "113",
        "name": "Niger"
      }, {
        "id": "114",
        "name": "Nigeria"
      }, {
        "id": "217",
        "name": "Niue"
      }, {
        "id": "214",
        "name": "Norfolk Island"
      }, {
        "id": "272",
        "name": "North Korea"
      }, {
        "id": "116",
        "name": "Norway"
      }, {
        "id": "117",
        "name": "Oman"
      }, {
        "id": "118",
        "name": "Pakistan"
      }, {
        "id": "222",
        "name": "Palau"
      }, {
        "id": "282",
        "name": "Palestine"
      }, {
        "id": "119",
        "name": "Panama"
      }, {
        "id": "219",
        "name": "Papua New Guinea"
      }, {
        "id": "120",
        "name": "Paraguay"
      }, {
        "id": "121",
        "name": "Peru"
      }, {
        "id": "122",
        "name": "Philippines"
      }, {
        "id": "221",
        "name": "Pitcairn"
      }, {
        "id": "123",
        "name": "Poland"
      }, {
        "id": "124",
        "name": "Portugal"
      }, {
        "id": "126",
        "name": "Qatar"
      }, {
        "id": "315",
        "name": "Republic of Kosovo"
      }, {
        "id": "127",
        "name": "Reunion"
      }, {
        "id": "128",
        "name": "Romania"
      }, {
        "id": "129",
        "name": "Russia"
      }, {
        "id": "130",
        "name": "Rwanda"
      }, {
        "id": "205",
        "name": "Saint Kitts and Nevis"
      }, {
        "id": "206",
        "name": "Saint Lucia"
      }, {
        "id": "237",
        "name": "Saint Vincent and the Grenadines"
      }, {
        "id": "132",
        "name": "Samoa (Independent)"
      }, {
        "id": "227",
        "name": "San Marino"
      }, {
        "id": "133",
        "name": "Saudi Arabia"
      }, {
        "id": "134",
        "name": "Senegal"
      }, {
        "id": "266",
        "name": "Serbia"
      }, {
        "id": "135",
        "name": "Seychelles"
      }, {
        "id": "136",
        "name": "Sierra Leone"
      }, {
        "id": "137",
        "name": "Singapore"
      }, {
        "id": "302",
        "name": "Sint Maarten"
      }, {
        "id": "138",
        "name": "Slovakia"
      }, {
        "id": "139",
        "name": "Slovenia"
      }, {
        "id": "223",
        "name": "Solomon Islands"
      }, {
        "id": "140",
        "name": "Somalia"
      }, {
        "id": "141",
        "name": "South Africa"
      }, {
        "id": "257",
        "name": "South Georgia and the South Sandwich Islands"
      }, {
        "id": "142",
        "name": "South Korea"
      }, {
        "id": "311",
        "name": "South Sudan"
      }, {
        "id": "143",
        "name": "Spain"
      }, {
        "id": "144",
        "name": "Sri Lanka"
      }, {
        "id": "293",
        "name": "Sudan"
      }, {
        "id": "146",
        "name": "Suriname"
      }, {
        "id": "225",
        "name": "Svalbard and Jan Mayen Islands"
      }, {
        "id": "147",
        "name": "Swaziland"
      }, {
        "id": "148",
        "name": "Sweden"
      }, {
        "id": "149",
        "name": "Switzerland"
      }, {
        "id": "285",
        "name": "Syria"
      }, {
        "id": "152",
        "name": "Taiwan"
      }, {
        "id": "260",
        "name": "Tajikistan"
      }, {
        "id": "153",
        "name": "Tanzania"
      }, {
        "id": "154",
        "name": "Thailand"
      }, {
        "id": "155",
        "name": "Togo"
      }, {
        "id": "232",
        "name": "Tonga"
      }, {
        "id": "234",
        "name": "Trinidad and Tobago"
      }, {
        "id": "156",
        "name": "Tunisia"
      }, {
        "id": "157",
        "name": "Turkey"
      }, {
        "id": "287",
        "name": "Turks &amp; Caicos Islands"
      }, {
        "id": "159",
        "name": "Uganda"
      }, {
        "id": "161",
        "name": "Ukraine"
      }, {
        "id": "162",
        "name": "United Arab Emirates"
      }, {
        "id": "262",
        "name": "United Kingdom"
      }, {
        "id": "163",
        "name": "Uruguay"
      }, {
        "id": "165",
        "name": "Uzbekistan"
      }, {
        "id": "239",
        "name": "Vanuatu"
      }, {
        "id": "166",
        "name": "Vatican City State (Holy See)"
      }, {
        "id": "167",
        "name": "Venezuela"
      }, {
        "id": "168",
        "name": "Vietnam"
      }, {
        "id": "169",
        "name": "Virgin Islands (British)"
      }, {
        "id": "238",
        "name": "Virgin Islands (U.S.)"
      }, {
        "id": "188",
        "name": "Western Sahara"
      }, {
        "id": "170",
        "name": "Yemen"
      }, {
        "id": "173",
        "name": "Zambia"
      }, {
        "id": "174",
        "name": "Zimbabwe"
      }];
      array.forEach(countries, lang.hitch(this, function (country) {
        var el = "<option value='" + country.id + "'>" + country.name + "</option>";
        domConstruct.place(el, this.countrySelectNode, "last");
      }));
      this.inherited(arguments);
    }
  });
  var EmailField = declare([_BaseField], {
    templateString: "<div class='field-wrapper'>" + "<label for='mc-${name}'>${label}</label>" + "<input type='text' name='${name}' value='' id='mc-${name}' />" + "</div>",
    validateAsType: "email"
  });
  var BirthdayField = declare([_BaseField], {
    templateString: "<div class='field-wrapper birthday'>" + "<label for='mc-${name}-month'>${label}</label>" + "<div data-dojo-attach-point='inputsContainer'>" + "<input class='birthday-month' type='text' placeholder='MM' maxlength='2' name='${name}[month]' value='' id='mc-${name}-month' data-dojo-attach-point='monthNode' />" + "<input class='birthday-day' type='text' placeholder='DD' maxlength='2' name='${name}[day]' value='' id='mc-${name}-day' data-dojo-attach-point='dayNode' />" + "</div>" + "</div>",
    validateAsType: "birthday",
    validateAsGroup: true,
    postCreate: function () {
      this.inherited(arguments);
      if (this.dateformat === "DD/MM") {
        domConstruct.place(this.dayNode, this.inputsContainer, "first");
        domConstruct.place(this.monthNode, this.inputsContainer, "last");
      }
    }
  });
  var DateField = declare([_BaseField], {
    templateString: "<div class='field-wrapper date'>" + "<label for='mc-${name}-month'>${label}</label>" + "<div data-dojo-attach-point='inputsContainer'>" + "<input class='date-year' type='text' maxlength='4' placeholder='YYYY' name='${name}[year]' value='' id='mc-${name}-year' data-dojo-attach-point='yearNode' />" + "<input class='date-month' type='text' maxlength='2' placeholder='MM' name='${name}[month]' value='' id='mc-${name}-month' data-dojo-attach-point='monthNode' />" + "<input class='date-day' type='text' maxlength='2' placeholder='DD' name='${name}[day]' value='' id='mc-${name}-day' data-dojo-attach-point='dayNode' />" + "</div>" + "</div>",
    validateAsType: "date",
    validateAsGroup: true,
    postCreate: function () {
      this.inherited(arguments);
      if (this.dateformat === "MM/DD/YYYY") {
        domConstruct.place(this.monthNode, this.inputsContainer, "first");
        domConstruct.place(this.yearNode, this.inputsContainer, "last");
      } else if (this.dateformat === "DD/MM/YYYY") {
        domConstruct.place(this.dayNode, this.inputsContainer, "first");
        domConstruct.place(this.yearNode, this.inputsContainer, "last");
      }
    }
  });
  var PhoneField = declare([_BaseField], {
    templateString: "<div class='field-wrapper phone'>" + "<label for='mc-${name}-area'>${label}</label>" + "<div>" + "<input class='phone-area' type='text' maxlength='3' placeholder='###' name='${name}[area]' value='' id='mc-${name}-area' data-dojo-attach-point='phoneAreaNode' />" + "<input class='phone-detail1' type='text' maxlength='3' placeholder='###' name='${name}[detail1]' value='' id='mc-${name}-detail1' data-dojo-attach-point='phoneDetail1Node' />" + "<input class='phone-detail2' type='text' maxlength='4' placeholder='####' name='${name}[detail2]' value='' id='mc-${name}-detail2' data-dojo-attach-point='phoneDetail2Node' />" + "</div>" + "</div>",
    validateAsType: "phone",
    validateAsGroup: true
  });
  var HiddenField = declare([_BaseField], {
    templateString: "<div class='field-wrapper'>" + "<input type='hidden' name='${name}' value='' id='mc-${name}' />" + "</div>"
  });
  var UrlField = declare([_BaseField], {
    templateString: "<div class='field-wrapper'>" + "<label for='mc-${name}'>${label}</label>" + "<input type='text' placeholder='http://' name='${name}' value='' id='mc-${name}' />" + "</div>",
    validateAsType: "url"
  });
  var RadioCheckboxField = declare([_BaseField], {
    templateString: "<div class='field-wrapper radio-group'>" + "<label for='mc-${name}'>${label}</label>" + "<ul class='radioCheckboxContainer' data-dojo-attach-point='choicesContainer'></ul>" + "</div>",
    validateAsType: "radiocheckbox",
    postCreate: function () {
      array.forEach(this.choices, lang.hitch(this, function (choice, i) {
        // Create a unique id for each choice for use with label, (e.g., group[3]-3-0 or MMERGE17-0)
        var id = this.merge_id ? this.name + "-" + i : this.name + "-" + this.group_id + "-" + i;
        id = "mc-" + id;
        var name, extras;
        if (this.type === "checkbox") {
          // If it's a checkbox, make the input name an array with values as keys
          name = this.name + "[" + choice.value + "]";
          extras = "<div class='checkbox-bg'></div>";
        } else {
          name = this.name;
          // Put an empty div within the label to render active radio button state
          extras = "<div class='radio-fill'></div>";
        }
        var input = domConstruct.create("input", {
          id: id,
          type: this.type,
          value: choice.value,
          name: name
        });
        var label = domConstruct.create("label", {
          "for": id,
          "class": this.type
        });
        var labelContent = document.createTextNode(choice.label);
        var backgroundSpan = domConstruct.create("div", {
          "class": "hover-focus-background"
        });
        var flexSpacer = domConstruct.create("div", {
          "class": "flex-spacer"
        });
        var li = domConstruct.create("li");
        domConstruct.place(input, label);
        domConstruct.place(labelContent, label);
        if (extras) {
          domConstruct.place(extras, label);
        }
        domConstruct.place(backgroundSpan, label);
        domConstruct.place(label, li);
        domConstruct.place(flexSpacer, li);
        domConstruct.place(li, this.choicesContainer, "last");
      }));
      this.inherited(arguments);
    }
  });
  var GdprCheckboxField = declare([_BaseField], {
    templateString: "<li class=\"field-wrapper !margin-bottom--lv2\">" + "<label class=\"checkbox\" for=\"gdpr-${marketing_preference_id}\">" + "<input type=\"checkbox\" id=\"gdpr-${marketing_preference_id}\" name=\"${name}\" data-dojo-attach-point=\"choicesContainer\" />" + "<span>${label}</span>" + "</label>" + "</li>",
    validateAsType: "radiocheckbox"
  });
  var SelectField = declare([_BaseField], {
    templateString: "<div class='field-wrapper'>" + "<label for='mc-${name}'>${label}</label>" + "<select name='${name}' id='mc-${name}' data-dojo-attach-point='choicesContainer'></select>" + "</div>",
    validateAsType: "select",
    postCreate: function () {
      var emptyOptionNodes = []; // Keep track of empty nodes. We'll set one of them to selected, or create one if none exist.
      array.forEach(this.choices, lang.hitch(this, function (choice) {
        var option = domConstruct.toDom("<option value='" + choice.value + "'>" + choice.label + "</option>");
        if (this._empty(choice.label)) {
          emptyOptionNodes.push(option);
        }
        domConstruct.place(option, this.choicesContainer, "last");
      }));
      // If there's no empty option, create one. Otherwise add 'selected' attribute to first empty option node.
      if (emptyOptionNodes.length > 0) {
        domAttr.set(emptyOptionNodes[0], "selected", "selected");
      } else {
        domConstruct.place("<option value='' selected='selected'></option>", this.choicesContainer, "first");
      }
      this.inherited(arguments);
    }
  });
  var GdprBlock = declare([_WidgetBase, _TemplatedMixin], {
    templateString: "<div class=\"content__gdprBlock\">" + "<div class=\"content__gdpr\">" + "<label>${gdprLabel}</label>" + "<p>${gdprDescription}</p>" + "<div data-dojo-attach-point=\"errorMessageNode\" class=\"errorText\"></div>" + "<ul class=\"content__gdprFields radioCheckboxContainer\" data-dojo-attach-point=\"gdprFieldsContainer\"></ul>" + "<p data-dojo-attach-point=\"gdprLegalContainer\"></p>" + "</div>" + "<div class=\"content__gdprLegal\">" + "<a href=\"https://www.mailchimp.com/gdpr\" target=\"_blank\"><img src=\"${iconImgUrl}\" alt=\"GDPR\" /></a>" + "<p data-dojo-attach-point=\"gdprMcLegalContainer\"></p>" + "</div>" + "</div>",
    gdprLabel: "",
    gdprDescription: "",
    gdprLegal: "",
    gdprMCLegal: "",
    errorMessage: "",
    _setErrorMessageAttr: {
      node: "errorMessageNode",
      type: "innerText"
    },
    iconImgUrl: "https://eep.io/mc-cdn-images/icons/mailchimp-gdpr.svg",
    postCreate: function () {
      this.inherited(arguments);
      domConstruct.place(this.gdprMCLegal, this.gdprMcLegalContainer);
      domConstruct.place(this.gdprLegal, this.gdprLegalContainer);
    }
  });
  var CaptchaField = declare([_BaseField], {
    templateString: "<div class='field-wrapper' style='margin-bottom: 6px;'>" + "<div data-dojo-attach-point='captchaNode' class='g-recaptcha' data-size='invisible'></div>" + "</div>",
    validateAsType: null,
    postCreate: function () {
      // eslint-disable-next-line no-undef
      grecaptcha.render(this.captchaNode, {
        sitekey: this.recaptchaSitekey,
        callback: lang.hitch(this, "captchaCallback")
      });
      this.inherited(arguments);
    },
    captchaCallback: function () {
      this.setFieldAsValid();
      this.emit("success", {});
    }
  });
  return declare("SignupForm", [_WidgetBase, _TemplatedMixin, Evented, _CustomStyleRulesMixin], {
    templateString: '<div class="webContent">' + '<div class="flash-block" data-dojo-attach-point="formResponseMessages"></div>' + '<div class="webContent__content" data-dojo-attach-point="formContentContainer">' + '<form action="${subscribeUrl}" accept-charset="UTF-8" method="post" enctype="multipart/form-data" data-dojo-attach-point="formNode" novalidate>' + '<div class="content__formFields" data-dojo-attach-point="formFieldsContainer"></div>' + '<div class="content__button">' + '<input class="button" type="submit" value="${buttonLabel}" data-dojo-attach-point="submitButton"/>' + "</div>" + "</form>" + "</div>" + "</div>",
    trackSubmitUrl: "#",
    subscribeUrl: "#",
    appDomain: "",
    honeypotFieldName: "",
    honeytime: "",
    recaptchaSitekey: "",
    captchaEnabled: false,
    fields: [],
    buttonLabel: "Subscribe",
    config: {},
    translations: {},
    constructor: function () {
      this.formIsValid = false;
      this.fieldNodes = [];
    },
    postMixInProperties: function () {
      // Pull values from the config
      this.fields = this.config.fields;
      globalConfig = this.config;
      if (this.config.buttonLabel) {
        var decodedLabel = entities.decode(this.config.buttonLabel);
        this.buttonLabel = decodedLabel;
      }
      if (this.config.styles) {
        this.styles = this.config.styles;
      }
    },
    postCreate: function () {
      // Update the height when CSS is finished loading
      var files = [];
      translations = this.translations;
      files.push(this.loadCustomCss());
      if (this.captchaEnabled) {
        files.push(this.loadCaptchaJs());
      }
      var hasEmailField = this.fields.some(function (field) {
        return field.type === "email";
      });
      if (!hasEmailField) {
        this.config.gdprEnabled = false;
      }
      all(files).then(lang.hitch(this, function () {
        // GDPR
        if (this.config.gdprEnabled) {
          this.gdprContent = new GdprBlock({
            gdprLabel: this.config.gdprLabel,
            gdprDescription: this.config.gdprDescription,
            // dom.Construct.toDom for HTML of gdprMCLegal to properly render.
            // surround with <span> to ensure valid HTML fragment.
            gdprLegal: domConstruct.toDom("<span>" + this.config.gdprLegal + "</span>"),
            gdprMCLegal: domConstruct.toDom("<span>" + this.config.gdprMCLegal + "</span>")
          });
          this.gdprContent.placeAt(this.formFieldsContainer, "after");
        }
        this.addFields();
        this.addHoneypot();
        this.addHoneytime();
        if (this.captchaEnabled) {
          var captchaField = this.addCaptcha();
          captchaField.on("success", lang.hitch(this, function () {
            this.submitForm();
          }));
        }
      }));
      on(this.formNode, "submit", lang.hitch(this, function (evt) {
        // Prevent page to navigate away
        evt.stopPropagation();
        evt.preventDefault();
        if (!this.isPreview) {
          request.get(this.trackSubmitUrl);
        }
        var formErrorsNode = query(".flash-errors", this.formResponseMessages)[0];
        if (formErrorsNode) {
          domStyle.set(formErrorsNode, "display", "none");
        }
        this._validateForm();
        if (this.formIsValid) {
          if (this.captchaEnabled) {
            // eslint-disable-next-line no-undef
            grecaptcha.execute(); // successful captcha completion callback calls submitForm
          } else {
            this.submitForm();
          }
        } else {
          this.emit("resizeFrame", {});
        }
      }));
    },
    addFields: function () {
      if (this.fieldNodes.length) {
        array.forEach(this.fieldNodes, function (input) {
          input.destroy();
        });
        this.fieldNodes = [];
        domConstruct.empty(this.formFieldsContainer);
        if (this.gdprContent && this.config.gdprEnabled) {
          domConstruct.empty(this.gdprContent.gdprFieldsContainer);
        }
      }
      array.forEach(this.fields, lang.hitch(this, function (fieldData) {
        if (fieldData.marketing_preference_id && !this.config.gdprEnabled) {
          return;
        }
        if (fieldData.type === "address") {
          fieldData.addr2 = this.translations.ADDR2;
          fieldData.zip = this.translations.ADDRZIP;
          fieldData.city = this.translations.ADDRCITY;
          fieldData.state = this.translations.ADDRSTATE;
          fieldData.country = this.translations.ADDRCOUNTRY;
        }
        var field = this._createField(fieldData);
        if (field) {
          if (this.gdprContent && this.config.gdprEnabled && fieldData.marketing_preference_id) {
            field.placeAt(this.gdprContent.gdprFieldsContainer);
          } else {
            field.placeAt(this.formFieldsContainer);
          }
          field.startup();
        }
      }));
    },
    addHoneypot: function () {
      var trap = domConstruct.toDom('<div style="position:absolute;left:-5000px;" aria-hidden="true"><input type="text" name="' + this.honeypotFieldName + '" tabindex="-1" value=""></div>');
      domConstruct.place(trap, this.formFieldsContainer, "last");
    },
    addHoneytime: function () {
      if (!this.honeytime) {
        return;
      }
      var ht = domConstruct.toDom('<input type="hidden" name="ht" value="' + this.honeytime + '">');
      domConstruct.place(ht, this.formFieldsContainer, "last");
    },
    addCaptcha: function () {
      var field = this._createField({
        type: "captcha",
        "recaptchaSitekey": this.recaptchaSitekey
      });
      field.placeAt(this.formFieldsContainer);
      field.startup();
      return field;
    },
    _validateForm: function () {
      var formErrors = [];
      array.forEach(this.fieldNodes, function (field) {
        var e = field.validateField();
        if (e.length > 0) {
          formErrors.push(e);
        }
      });
      this.formIsValid = !(formErrors.length > 0);
    },
    submitForm: function () {
      var customer_session_id_param = cookie("mc_customer_session_id") === undefined ? "" : "&customer_session_id=" + encodeURIComponent(cookie("mc_customer_session_id"));
      request.get(this.subscribeUrl, domForm.toQuery(this.formNode) + customer_session_id_param).then(lang.hitch(this, function (response) {
        if (response.result === "error") {
          this._handleErrorResponse(response);
        } else {
          this._handleSuccessResponse(response);
        }
        this.emit("resizeFrame", {});
      }));
    },
    _createField: function (fieldData) {
      var field;
      switch (fieldData.type) {
        case "email":
          field = new EmailField(fieldData);
          break;
        case "captcha":
          field = new CaptchaField(fieldData);
          break;
        case "address":
          field = new AddressField(fieldData);
          break;
        case "birthday":
          field = new BirthdayField(fieldData);
          break;
        case "date":
          field = new DateField(fieldData);
          break;
        case "smsphone":
          field = new SmsPhoneField(fieldData);
          break;
        case "phone":
          field = fieldData.phoneformat === "US" ? new PhoneField(fieldData) : new TextField(fieldData);
          break;
        case "number":
          field = new NumberField(fieldData);
          break;
        case "select":
        case "dropdown":
          field = new SelectField(fieldData);
          break;
        case "hidden":
          field = new HiddenField(fieldData);
          break;
        case "radio":
        case "checkbox":
          if (fieldData.marketing_preference_id) {
            field = new GdprCheckboxField(fieldData);
          } else {
            field = new RadioCheckboxField(fieldData);
          }
          break;
        case "url":
        case "image":
          field = new UrlField(fieldData);
          break;
        case "text":
        default:
          field = new TextField(fieldData);
      }
      if (field) {
        this.fieldNodes.push(field);
      }
      return field;
    },
    _teardownFormWithMessage: function (message) {
      // Make a form success response div if one doesn't already exist
      var formSuccessNode = query(".signup-success", this.formResponseMessages)[0];
      if (!formSuccessNode) {
        formSuccessNode = domConstruct.place('<div class="signup-success"></div>', this.formResponseMessages);
      }
      var formErrorsNode = query(".flash-errors", this.formResponseMessages)[0];
      if (formErrorsNode) {
        domStyle.set(formErrorsNode, "display", "none");
      }
      if (this.gdprContent) {
        this.gdprContent.set("errorMessage", "");
      }

      // Reset the form
      this.formNode.reset();

      // Reset inline field validation
      array.forEach(this.fieldNodes, function (input) {
        input.resetField();
      });

      // Hide the form
      domStyle.set(this.formContentContainer, "display", "none");
      html.set(formSuccessNode, message);
    },
    _handleRedirect: function (url) {
      var linkUrl = domConstruct.create("a", {
        href: url
      });
      domConstruct.place(document.createTextNode(url), linkUrl);
      var redirectMessage = "Success! You will now be redirected to " + linkUrl.outerHTML;
      var redirectPreviewMessage = "Success! After the signup form is submitted, visitors will be sent to " + url;
      if (this.isPreview) {
        var toaster = new Toaster();
        toaster.setContent(redirectPreviewMessage, "message");
        toaster.placeAt(document.querySelector("body"));
        return;
      }
      this._teardownFormWithMessage(redirectMessage);
      window.location = url;
    },
    _handleSuccessResponse: function (response) {
      if (window.mc_process_engagement_post_signup) {
        window.mc_process_engagement_post_signup();
      }
      // Show confirmation message after signup
      if (this.config.successAction === "message") {
        this._teardownFormWithMessage(response.msg);
        return;
      }

      // Redirect users after signup
      if (this.config.successAction === "redirect") {
        var redirectUrl = this.config.successRedirectUrl;
        this._handleRedirect(redirectUrl);
      }
    },
    _handleErrorResponse: function (response) {
      // Reset GDPR error messaging
      if (this.gdprContent) {
        this.gdprContent.set("errorMessage", "");
      }

      // Hide form success response div if exists
      var formSuccessNode = query(".signup-success", this.formResponseMessages)[0];
      if (formSuccessNode) {
        domStyle.set(formSuccessNode, "display", "none");
      }

      // Display form error if one exists
      if (response.msg) {
        // Allow error message to be overwriten
        var flashMessage = response.msg;
        if (this.gdprContent && response.type === "GDPR") {
          flashMessage = "Something went wrong. Fix the errors to subscribe.";
          this.gdprContent.set("errorMessage", response.msg);
        }
        var formErrorsNode = "<div class=\"flash-errors\">" + flashMessage + "</div>";
        domConstruct.place(formErrorsNode, this.formResponseMessages, "only");
      }

      // Display any field-specific error messages inline
      if (response.errors) {
        array.forEach(this.fieldNodes, function (input) {
          if (response.errors.hasOwnProperty(input.merge_id)) {
            input.setFieldAsInvalid(response.errors[input.merge_id]);
          } else if (response.errors.hasOwnProperty(input.type)) {
            input.setFieldAsInvalid(response.errors[input.type]);
          } else {
            input.setFieldAsValid();
          }
        });
      }
      if (this.captchaEnabled) {
        // eslint-disable-next-line no-undef
        grecaptcha.reset();
      }
    },
    toHTML: function () {
      return this.domNode.outerHTML;
    },
    loadCaptchaJs: function () {
      var captchaDeferred = new Deferred();
      var captcha = document.createElement("script");
      captcha.type = "text/javascript";
      captcha.src = "https://www.google.com/recaptcha/api.js";
      on(captcha, "load", lang.hitch(this, function () {
        var timer = setInterval(function () {
          var recaptchaLoaded = typeof grecaptcha !== "undefined"
          // eslint-disable-next-line no-undef
          && typeof grecaptcha.render !== "undefined"
          // eslint-disable-next-line no-undef
          && typeof grecaptcha.execute !== "undefined"
          // eslint-disable-next-line no-undef
          && typeof grecaptcha.reset !== "undefined";
          if (recaptchaLoaded) {
            clearInterval(timer);
            captchaDeferred.resolve();
          }
        }, 100);
      }));
      document.getElementsByTagName("head")[0].appendChild(captcha);
      return captchaDeferred.promise;
    },
    loadCustomCss: function () {
      if (this.customCssNode) {
        domConstruct.destroy(this.customCssNode);
      }
      var customDeferred = new Deferred();
      this.customCssNode = this.createStyleNode(document);
      var sheet = this.getStyleSheet(this.customCssNode);
      if (this.styles.hasOwnProperty("neapolitan")) {
        this.styles.neapolitan.forEach(function (style) {
          var props = Object.keys(style.props);
          props.forEach(function (prop) {
            this.addCSSRule(sheet, style.selector, prop + ": " + style.props[prop].value + ";");
          }.bind(this));
        }.bind(this));

        // add button alignment and button styles??
        if (this.styles.hasOwnProperty("formStyles")) {
          for (var formButtonStyle in this.styles.formStyles) {
            if (this.styles.formStyles.hasOwnProperty(formButtonStyle)) {
              this._addAlignmentStyles(this, sheet, this.styles.formStyles, formButtonStyle);
            }
          }
        }
      } else {
        // should never be in a state where neapolitan doesn't exist without the flag.
        // when we turn the flag off, on style with neapolitan styles when they exist
        // only for button and label, not neapolitan and formStyles in formConfig.styles
        if (this.styles.hasOwnProperty("button")) {
          // _addButtonStyles
          this._addButtonStyles(this, sheet, this.config.styles, "button");
        }
        if (this.styles.hasOwnProperty("labels")) {
          // _addLabelStyles
          this._addLabelStyles(this, sheet, this.config.styles, "labels");
        }
      }
      customDeferred.resolve();
      return customDeferred.promise;
    },
    /**
     * _addButtonStyles
     * @param {Object} signupFormContainer is the module object
     * @param {Object} sheet is the stylesheet to which to add style
     * @param {Object} stylesInFormConf is the formConfig style object to process specific styled elements
     * @param {String} domElKey is the object key for which DOM element is represented
     */
    _addButtonStyles: function (signupFormContainer, sheet, stylesInFormConf, domElKey) {
      // addCSSRule from _CustomStyleRulesMixin
      for (var domElProp in stylesInFormConf[domElKey]) {
        if (stylesInFormConf[domElKey].hasOwnProperty(domElProp)) {
          switch (domElProp) {
            case "color":
              signupFormContainer.addCSSRule(sheet, ".webContent__content .button", "background-color:" + stylesInFormConf[domElKey][domElProp] + ";");
              break;
            case "hover_color":
              signupFormContainer.addCSSRule(sheet, ".webContent__content .button:hover", "background-color:" + stylesInFormConf[domElKey][domElProp] + ";");
              break;
            case "text_color":
              signupFormContainer.addCSSRule(sheet, ".webContent__content .button", "color:" + stylesInFormConf[domElKey][domElProp] + ";");
              break;
            case "border":
              signupFormContainer.addCSSRule(sheet, ".webContent__content .button", "border:" + stylesInFormConf[domElKey][domElProp] + ";");
              break;
            case "alignment":
              if (stylesInFormConf[domElKey][domElProp] === "right") {
                signupFormContainer.addCSSRule(sheet, ".webContent__content .button", "float:right;");
              } else if (stylesInFormConf[domElKey][domElProp] === "center") {
                signupFormContainer.addCSSRule(sheet, ".webContent__content .button", "float:none;margin-left:auto;margin-right:auto;");
                if (has("ie") <= 9) {
                  signupFormContainer.addCSSRule(sheet, ".webContent__content .button", "display:table-cell;");
                  signupFormContainer.addCSSRule(sheet, ".webContent__content .content__button", "margin-left:auto;margin-right:auto;display:table;");
                } else {
                  signupFormContainer.addCSSRule(sheet, ".webContent__content .button", "display:table;");
                }
              } else {
                signupFormContainer.addCSSRule(sheet, ".webContent__content .button", "float:left;");
              }
              break;
            case "style":
              if (stylesInFormConf[domElKey][domElProp] === "full") {
                signupFormContainer.addCSSRule(sheet, ".webContent__content .button", "width:100%;");
              } else {
                signupFormContainer.addCSSRule(sheet, ".webContent__content .button", "width:auto;");
              }
              break;
            default:
              break;
          }
          // add max-width on container but old style
          signupFormContainer.addCSSRule(sheet, ".mcnSignUpFormContentContainer", "max-width: 450px");
        }
      }
    },
    /**
     * _addLabelStyles
     * @param {Object} signupFormContainer is the module object
     * @param {Object} sheet is the stylesheet to which to add style
     * @param {Object} stylesInFormConf is the formConfig style object to process specific styled elements
     * @param {String} domElKey is the object key for which DOM element is represented
     */
    _addLabelStyles: function (signupFormContainer, sheet, stylesInFormConf, domElKey) {
      // addCSSRule from _CustomStyleRulesMixin
      for (var domElProp in stylesInFormConf[domElKey]) {
        if (stylesInFormConf[domElKey].hasOwnProperty(domElProp)) {
          switch (domElProp) {
            case "color":
              signupFormContainer.addCSSRule(sheet, ".webContent__content label", "color:" + stylesInFormConf[domElKey][domElProp] + ";");
              break;
            case "font":
              signupFormContainer.addCSSRule(sheet, ".webContent__content label", "font-family:" + stylesInFormConf[domElKey][domElProp] + ";");
              break;
            default:
              break;
          }
        }
      }
    },
    /**
     * _addAlignmentStyles
     * @param {Object} signupFormContainer is the module object
     * @param {Object} sheet is the stylesheet to which to add style
     * @param {Object} stylesInFormConf is the formConfig style object to process specific styled elements
     * @param {String} domElKey is the object key for which DOM element is represented2
     */
    _addAlignmentStyles: function (signupFormContainer, sheet, stylesInFormConf, domElKey) {
      // addCSSRule from _CustomStyleRulesMixin
      switch (domElKey) {
        case "buttonAlignment":
          if (stylesInFormConf[domElKey] === "right") {
            signupFormContainer.addCSSRule(sheet, ".webContent__content .button", "float:right;");
          } else if (stylesInFormConf[domElKey] === "center") {
            signupFormContainer.addCSSRule(sheet, ".webContent__content .button", "float:none;margin-left:auto;margin-right:auto;");
            if (has("ie") <= 9) {
              signupFormContainer.addCSSRule(sheet, ".webContent__content .button", "display:table-cell;");
              signupFormContainer.addCSSRule(sheet, ".content__button", "margin-left:auto;margin-right:auto;display:table;");
            } else {
              signupFormContainer.addCSSRule(sheet, ".webContent__content .button", "display:table;");
            }
          } else {
            signupFormContainer.addCSSRule(sheet, ".webContent__content .button", "float:left;");
          }
          break;
        case "buttonWidthStyle":
          if (stylesInFormConf[domElKey] === "full") {
            signupFormContainer.addCSSRule(sheet, ".webContent__content .button", "width:100%;");
          }
          break;
        case "formWidth":
          signupFormContainer.addCSSRule(sheet, ".mcnSignUpFormContentContainer", "flex:0 0 " + stylesInFormConf[domElKey]);
          break;
        default:
          break;
      }
    }
  });
});